import type { IconSvgObject } from './types';

const Navigator01Icon: IconSvgObject = [
  ["path", { d: "M4 3V21M20 3V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.9997 14L8 21L12 19.5L16 20.9995L11.9997 14Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 3V5M12 8V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Navigator01Icon;
